import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _cloneDeep from 'lodash/cloneDeep';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isObjectLike from 'lodash/isObjectLike';
import { BOTPRESS_DEFAULT_CONFIG } from '../../constants';

/**
 * Merges two objects, with values from overrideObj taking precedence over defaultObj.
 * Only non-null/undefined values from overrideObj are merged.
 * For nested objects, merging is done recursively.
 *
 * @param {Object} defaultObj - The default object to merge into
 * @param {Object} overrideObj - The object containing override values
 * @returns {Object} A new merged object
 *
 * @example
 * const default = { a: 1, b: { c: 2 } };
 * const override = { b: { d: 3 } };
 * mergeObjectIfNotEmpty(default, override);
 * // Returns: { a: 1, b: { c: 2, d: 3 } }
 *
 * @example
 * const default = { a: undefined, b: 1 };
 * const override = { a: null, b: null };
 * mergeObjectIfNotEmpty(default, override);
 * // Returns: { a: undefined, b: 1 }
 */
export function mergeObjectIfNotEmpty(defaultObj, overrideObj) {
  if (_isNil(overrideObj) || _isObjectLike(overrideObj) && _isEmpty(overrideObj)) {
    return defaultObj;
  }
  var result = _cloneDeep(defaultObj);
  Object.entries(overrideObj).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (!_isNil(value)) {
      // Only recursively merge if both values are objects
      if (_isObjectLike(value) && _isObjectLike(defaultObj[key])) {
        result[key] = mergeObjectIfNotEmpty(defaultObj[key], value);
      } else {
        result[key] = value;
      }
    }
  });
  return result;
}
export function createConfig() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return mergeObjectIfNotEmpty(BOTPRESS_DEFAULT_CONFIG, overrides);
}